import React from 'react'
import { Form, Input, Label, Header, Segment, Grid, GridColumn, GridRow, Container, Icon } from 'semantic-ui-react'
import Timer from './Timer'
import { connect } from 'react-redux'
import soundUrlAnswGood from '../assets/000003.mp3'
import soundUrlAnswBad from '../assets/000004.mp3'


class FormSevenWords extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            answer: '',
            starting_time: null,
            msToAnswer: props.msToAnswer,
            sevenWords:props.sevenWords,
            number:props.number,
            jump:props.jump,
            playerNumber:props.playerNumber,
            isRunning:true,
            rightAnswer: false,
            soundWrong1:false,
            soundWrong2:false,
            soundWrong3:false,
            soundWrong4:false,
            numberOfMistakes:0,

        }
        this.textInput = null;

        this.setTextInputRef = element => {
          this.textInput = element;
        };
    
        this.focusTextInput = () => {
          // Focus the text input using the raw DOM API
          if (this.textInput) this.textInput.focus();
          if (this.textInput) this.textInput.select();
        };
    }

    componentDidMount() {
        this.setState({ starting_time: Date.now() })
        this.focusTextInput();
    }

    onAnswerChange = (e) => {
        this.setState({ answer: e.target.value })
    }

    onSubmit = (e) => {
        e.preventDefault()
        let toGuess = this.state.sevenWords.answer;
        if (this.state.answer.toUpperCase() == toGuess.toUpperCase()){
            this.setState({msToAnswer:this.state.msToAnswer, isRunning:false, rightAnswer:true})
        }else{
            this.setState({msToAnswer:this.state.msToAnswer-this.state.jump})
            let numbMist = this.state.numberOfMistakes;
                switch(this.state.numberOfMistakes){
                    case 0:
                        this.setState({soundWrong1:true, numberOfMistakes:numbMist+1 })
                        break;
                    case 1:
                        this.setState({soundWrong2:true, numberOfMistakes:numbMist+1 })
                        break;
                    case 2:
                        this.setState({soundWrong3:true, numberOfMistakes:numbMist+1 })
                        break;
                    case 3:
                        this.setState({soundWrong4:true, numberOfMistakes:numbMist+1 })
                        break;
                    default:
                        break;
                }
        }
        return false
    }

    handleAnswer = (result) =>{
        this.setState({isRunning:false})
    }

    onTimerFinished = () => {
        this.setState({isRunning:false})
    }



    createNeedToAnswer = (rightAnswer,soundWrong1, soundWrong2, soundWrong3, soundWrong4) =>{
        return(
            <Container textAlign='center'>
                <Header as='h2' style={{ fontWeight: 'normal' }}>"FAI LA TUA PARTE "</Header>
                {"C'è una domanda spezzettata in sette parti. Sette giocatori hanno le sette parti."}
                {"Tu sei quello che deve inserire la risposta, dopo che hai sentito tutta la domanda!"}
            <Form onSubmit={this.onSubmit} style={{ textAlign: 'left' }}>
                {rightAnswer?<audio ref="audio_tag" src={soundUrlAnswGood} autoPlay/>:""}
                {soundWrong1?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                {soundWrong2?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                {soundWrong3?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                {soundWrong4?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                    <div style={{ textAlign: 'center' }}>
                        <Form.Field>
                            <Input onChange={this.onAnswerChange}>
                                <input ref={this.setTextInputRef} value={this.state.answer} style={{ textAlign: 'center' }} />
                            </Input>
                        </Form.Field>
                        <Form.Button primary type="submit">Rispondi</Form.Button>   
                    </div>
            </Form>
            </Container>
        )
    }


    createNoNeedToAnswer = (word, number) =>{
        return (
            <Container textAlign='center'>
                <Header as='h2' style={{ fontWeight: 'normal' }}>"FAI LA TUA PARTE "</Header>
                {"C'è una domanda spezzettata in sette parti. Tu sei la parte numero"}
                <Header as='h2' style={{ fontWeight: 'normal' }}>{number+1}</Header>
                {"Quando tocca a te dilla ad alta voce così da permettere a chi deve rispondere di farlo!"}
                <Grid centered celled>
                    <GridRow >
                    <GridColumn centered width={8}>
                    <Container textAlign='center'>
                    <Label size={'huge'} color={'blue'}> <Icon name='puzzle'/> 
                            {word}
                    </Label>
                        </Container>
                    </GridColumn>
                    </GridRow>
                </Grid>
            </Container>
        )
    }

    render() {
        const {msToAnswer, sevenWords, number, rightAnswer,soundWrong1, soundWrong2, soundWrong3, soundWrong4, isRunning } = this.state
        let word = "";
        let needToAnswer = false;
        if (!isRunning) setTimeout(this.props.onGameEnded,2000); 
        switch (number){
            case 0:
                word = sevenWords.word1;
                break;
            case 1:
                word = sevenWords.word2;
                break;
            case 2:
                word = sevenWords.word3;
                break;
            case 3:
                word = sevenWords.word4;
                break;
            case 4:
                word = sevenWords.word5;
                break;
            case 5:
                word = sevenWords.word6;
                break;6
            case 6:
                word = sevenWords.word7;
                break;
            case 6:
                word = sevenWords.word9;
                break;
            case 7:
                needToAnswer = true;
                break;
            default:
                break;
        }
        return (
            <div>
                <Segment style={{ maxWidth: '800px', margin: 'auto' }}>
                    <Label color='purple' ribbon>{"La domanda spezzatino"}</Label>
                    <div style={{ textAlign: 'center' }}>
                        {needToAnswer?
                            this.createNeedToAnswer(rightAnswer,soundWrong1, soundWrong2, soundWrong3, soundWrong4)
                        :
                            this.createNoNeedToAnswer(word,number)
                        }
                        <Timer  ms={msToAnswer} isReady={true} bar={false} isRunning={this.state.isRunning} handleAnswer={needToAnswer?this.props.handleAnswer:this.handleAnswer} onTimerFinished ={this.onTimerFinished}/>
                    </div>
                    <Timer  ms={msToAnswer} isReady={true} isRunning={this.state.isRunning} bar={true}  handleAnswer={needToAnswer?this.props.handleAnswer:this.handleAnswer}  />
                </Segment>
            </div>
        )
    }

}

const mapStateToProps = (state, { isLogged }) => ({
    state : state, 
    user: state.user,
    isLogged,
    sevenWords:state.game?state.game.sevenWords:undefined,
    number:state.game?state.game.number:undefined,
})

const mapDispatchToProps = (dispatch, {socket}) => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FormSevenWords)


// WEBPACK FOOTER //
// ./src/components/FormSevenWords.js